import { render } from "./SubMenuDesktop.vue?vue&type=template&id=4ecf3f5f&scoped=true"
import script from "./SubMenuDesktop.vue?vue&type=script&lang=js"
export * from "./SubMenuDesktop.vue?vue&type=script&lang=js"

import "./SubMenuDesktop.vue?vue&type=style&index=0&id=4ecf3f5f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecf3f5f"]])

export default __exports__